// projects/humanresources-personnel/src/assets/i18n/*/hr-per-court.json
export class HrPerCourtKey {
    private static readonly keyPrefix = 'hrPerCourt';
    public static title = `${HrPerCourtKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerCourtKey.keyPrefix}.pageHeader`;
    public static lawsuitTypeId = `${HrPerCourtKey.keyPrefix}.lawsuitTypeId`;
    public static lawsuitSubtypeId = `${HrPerCourtKey.keyPrefix}.lawsuitSubtypeId`;
    public static subject = `${HrPerCourtKey.keyPrefix}.subject`;
    public static basicNumber = `${HrPerCourtKey.keyPrefix}.basicNumber`;
    public static basicDate = `${HrPerCourtKey.keyPrefix}.basicDate`;
    public static finalDecision = `${HrPerCourtKey.keyPrefix}.finalDecision`;
    public static decisionNumber = `${HrPerCourtKey.keyPrefix}.decisionNumber`;
    public static decisionDate = `${HrPerCourtKey.keyPrefix}.decisionDate`;
    public static finalizationDate = `${HrPerCourtKey.keyPrefix}.finalizationDate`;
    public static realBirthDate = `${HrPerCourtKey.keyPrefix}.realBirthDate`;
    public static changedBirthDate = `${HrPerCourtKey.keyPrefix}.changedBirthDate`;
    public static realName = `${HrPerCourtKey.keyPrefix}.realName`;
    public static changedName = `${HrPerCourtKey.keyPrefix}.changedName`;
    public static realSurname = `${HrPerCourtKey.keyPrefix}.realSurname`;
    public static changedSurname = `${HrPerCourtKey.keyPrefix}.changedSurname`;
    public static numberOfDaysEvaluated = `${HrPerCourtKey.keyPrefix}.numberOfDaysEvaluated`;
    public static lawsuitStage = `${HrPerCourtKey.keyPrefix}.lawsuitStage`;
    public static lawsuitStageName = `${HrPerCourtKey.lawsuitStage}.name`;
    public static lawsuitStageStageNumber = `${HrPerCourtKey.lawsuitStage}.stageNumber`;
    public static lawsuitStageExplanation = `${HrPerCourtKey.lawsuitStage}.explanation`;
    public static lawsuitStageStageDate = `${HrPerCourtKey.lawsuitStage}.stageDate`;
    public static lawsuitStageNotificationDate = `${HrPerCourtKey.lawsuitStage}.notificationDate`;
    public static lawsuitStagePracticeDate = `${HrPerCourtKey.lawsuitStage}.practiceDate`;
    public static lawsuitStageCourtStage = `${HrPerCourtKey.lawsuitStage}.courtStage`;
    public static lawsuitTypeSubtype = `${HrPerCourtKey.keyPrefix}.lawsuitTypeSubtype`;
}
